import { Grid, Typography } from "@mui/material";

const FeesInformation = ({ contractTerms }) => {
  return (
    <Grid
      container
      item
      xs={12}
      margin={"24px 0px"}
      sx={{
        border: "1px solid grey",
        borderRadius: "8px",
        borderColor: "#E9EBF0",
      }}
    >
      <Grid
        item
        flexGrow={1}
        xs={6}
        sx={{
          borderRight: "1px solid grey",
          padding: "20px 0px",
          borderColor: "#E9EBF0",
        }}
      >
        <Typography
          sx={{
            ml: "8px",
            fontWeight: 400,
            fontSize: "14px",
            color: "#00010C",
          }}
          noWrap
        >
          {`Taxa de juros (%a.m) - ${contractTerms?.taxMonthPercent}%`}
        </Typography>
      </Grid>
      <Grid
        item
        sx={{
          padding: "20px 0px",
          borderColor: "#E9EBF0",
        }}
        flexGrow={1}
        xs={6}
      >
        <Typography
          sx={{
            ml: "8px",
            fontWeight: 400,
            fontSize: "14px",
            color: "#00010C",
          }}
          noWrap
        >
          {`CET (%a.a) - ${contractTerms.cetPercent}%`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default FeesInformation;
